import { RefObject, useLayoutEffect, useRef, useState } from 'react'

/**
 * Whether an element cuts its content along an axis (`scroll*` past `client*`), measured where there is a layout and
 * again when it resizes: the previews' "more" and "See more". Null without a layout (jsdom), where the caller falls
 * back on a rule of its own.
 */
export const useMeasuredCut = <T extends HTMLElement>(content: string, axis: 'width' | 'height'): [RefObject<T>, boolean | null] => {
  const ref = useRef<T>(null)
  const [cut, setCut] = useState<boolean | null>(null)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return
    const measure = () => {
      const [scroll, client] = axis === 'width' ? [element.scrollWidth, element.clientWidth] : [element.scrollHeight, element.clientHeight]
      setCut(client ? scroll > client : null)
    }
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [content, axis])

  return [ref, cut]
}
